import React from 'react';
import clsx from 'clsx';
import { ReactComponent as IconLock } from 'images/lock.svg';
import { ReactComponent as IconEye1 } from 'images/pass-hidden.svg';
import { ReactComponent as IconEye2 } from 'images/eye2.svg';
import styles from './Input.module.scss';
import passStyles from './PassInput.module.scss';

type PassInputProps = {
  className?: string,
  onChange: (e: React.FormEvent<HTMLInputElement>) => void,
  value?: string,
  name?: string,
  placeholder?: string,
  disabled?: boolean,
  isVisible?: boolean,
  switchVisibility: () => void,
  error?: boolean,
  errorMessage?: string,
  onBlur?: () => void,
  white?: boolean,
  wide?: boolean,
  autoComplete?: string
}

function PassInput({
  className = '',
  onChange,
  value = '',
  name = '',
  placeholder = '',
  disabled = false,
  isVisible = false,
  switchVisibility,
  error = false,
  errorMessage = '',
  white = false,
  wide = false,
  autoComplete = '',
  ...restInputProps
}: PassInputProps) {
  const IconEye = isVisible ? IconEye2 : IconEye1
  return (
    <>
      <div
        className={clsx(
          styles.container,
          wide && styles.containerWide,
          error && styles.error,
          disabled && styles.containerDisabled,
          (value === '') && styles.containerEmpty,
          white && styles.containerWhite,
          className,
        )}
      >
        <div className={styles.prefix}>
          <IconLock />
        </div>
        <input
          value={value}
          name={name}
          onChange={onChange}
          className={clsx(styles.input, white && styles.inputWhite)}
          disabled={disabled}
          type={isVisible ? 'text' : 'password'}
          placeholder={placeholder}
          maxLength={400}
          autoComplete={autoComplete}
          {...restInputProps}
        />
        <div className={clsx(styles.suffix, passStyles.suffix)}>
          <IconEye
            onClick={switchVisibility}
          />
        </div>
      </div>
      {(error && errorMessage) && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
    </>
  )
}

export default PassInput
